import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IoArrowBackSharp, IoChevronBackSharp } from 'react-icons/io5';
import { ReactComponent as Arrow } from '../../../assets/images/svg/angle-right-small.svg';
import { useIntl } from 'react-intl';
import { Flex, MediaQuery } from '@mantine/core';
import { ReservationPolicyWrapper } from './styles';
import { getLangState } from '../../../store/lang.slice';

export default function ReservationPolicy() {
  const { formatMessage } = useIntl();
  const langType = useSelector(getLangState);
  const navigate = useNavigate();

  return (
    <ReservationPolicyWrapper>
      <Flex direction="column" gap="8px" className="wrapper">
        <Flex
          gap="8px"
          w="100%"
          align="center"
          className="backBtn link"
          onClick={() => navigate(-1)}
        >
          <MediaQuery styles={{ display: 'none' }} largerThan="md">
            {langType === 'ar' ? <Arrow /> : <IoArrowBackSharp />}
          </MediaQuery>
          <span className="backIcon">
            {langType === 'ar' ? <Arrow /> : <IoChevronBackSharp />}
          </span>
          <span>{formatMessage({ id: 'back' })}</span>
        </Flex>
        <h2>الشروط الخاصة بطلب الخدمة</h2>
        <div>
          <p className="firstParagraph">
            لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو
            أيوسمود تيمبور أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت
            انيم أد مينيم فينايم,كيواس نوستريد
          </p>
        </div>
        <h2>شروط الالغاء</h2>
        <div>
          <p className="firstParagraph">
            لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو
            أيوسمود تيمبور أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت
            انيم أد مينيم فينايم,كيواس نوستريد أكسير سيتاشن يللأمكو لابورأس نيسي
            يت أليكيوب أكس أيا كوممودو كونسيكيوات . ديواس
          </p>
          <p>
            أيوتي أريري دولار إن ريبريهينديرأيت فوليوبتاتي فيلايت أيسسي كايلليوم
            دولار أيو فيجايت نيولا باراياتيور. أيكسسيبتيور ساينت أوككايكات
            كيوبايداتات نون بروايدينت ,سيونت ان كيولبا كيو أوفيسيا
            ديسيريونتموليت انيم أيدي ايست لابوريوم." "سيت يتبيرسبايكياتيس يوندي
            أومنيس أستي ناتيس أيررور سيت فوليبتاتيم أكيسأنتييوم
          </p>
          <p>
            دولاريمكيو لايودانتيوم,توتام ريم أبيرأم,أيكيو أبسا كيواي أب أللو
            أنفينتوري فيرأتاتيس ايت كياسي أرشيتيكتو بيتاي فيتاي ديكاتا سيونت
            أكسبليكابو. نيمو أنيم أبسام فوليوباتاتيم كيواي فوليوبتاس سايت
            أسبيرناتشر أيوت أودايت أيوت فيوجايت, سيد كيواي كونسيكيونتشر ماجناي
            لا باراياتيور؟"
          </p>
        </div>
      </Flex>
    </ReservationPolicyWrapper>
  );
}
